import React from 'react';
import Logo from '../../assets/images/logo-Spiria.png';
import Slogan from '../../assets/images/slogan.png';

const Footer = () => {
    return (
        <div className="footer-wrapper">
            <div className="footer">
                <img className="spiria-logo" alt="Spiria" src={Logo} />
                <img className="spiria-slogan" alt="Penser. Coder. Collaborer." src={Slogan} />
            </div>
        </div>
    );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/dashboard/Footer.js